





















































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import CbxProductProvider from "@/views/lookups/CbxProductProvider.vue";
import ApiFactory from "../../api/ApiFactory";
import CbxMortgageRateType from "@/views/lookups/CbxMortgageRateType.vue";
import CbxPolicyStatus from "@/views/lookups/CbxPolicyStatus.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxPaymentFrequency from "@/views/lookups/CbxPaymentFrequency.vue";
import CbxMortgageType from "@/views/lookups/CbxMortgageType.vue";
import CbxApprovalStatus from "@/views/lookups/CbxApprovalStatus.vue";
import AlertService from "../../services/alert.service";
import {
  FactFindPolicyDto,
  CreateLiabilityMortgageCommand,
  YesNoDefaultDto,
  OwnerDto,
  ProductProviderDto,
  MortgageRateDto,
  PaymentFrequencyDto,
  PolicyStatusDto,
  MortgageTypeDto,
  UpdateLiabilityMortgageCommand,
  ClientSelector,
  PolicyAdditionalDetailsDto,
  FactFindDetailsDto,
  CreatePolicyDetailsCommand,
  UpdatePolicyDetailsCommand
} from "@/api/ClientPortalApiClient";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "../../filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxPolicyStatus,
    CbxYesNoDefault,
    CbxMortgageType,
    CbxProductProvider,
    CbxMortgageRateType,
    CbxPaymentFrequency
  }
})
export default class FactFindLiabilityMortgage extends Vue {
  private alertService = new AlertService();
  private mortgages: FactFindPolicyDto[] = [];
  private emptyMortgage = new FactFindPolicyDto();
  private selectMortgage = new FactFindPolicyDto();
  private emptyDetails = new PolicyAdditionalDetailsDto();
  private displayModel = new FactFindPolicyDto();
  private displayDetails = new PolicyAdditionalDetailsDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private clientNames: OwnerDto[] = [];
  private modelSig = "";
  private modalAdressTitle: string = "Address";
  private clientDetails = new FactFindDetailsDto();
  private displayAddress = "";
  private contactId: number = 0;

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.displayModel.additionalDetails = new PolicyAdditionalDetailsDto();
    await this.loadMortgages(true);
    await this.getClientSelectorNames();
    await this.getClientSelectorDetails();
  }

  $refs!: {
    owner: CbxOwner;
    policyStatus: CbxPolicyStatus;
    mortgageType: CbxMortgageType;
    productProvider: CbxProductProvider;
    mortgageRateType: CbxMortgageRateType;
    paymentFrequency: CbxPaymentFrequency;
    privateResidence: CbxYesNoDefault;
    investmentProperty: CbxYesNoDefault;
    rentalIncome: CbxYesNoDefault;
    mainForm: HTMLFormElement;
  };

  hideModal() {
    this.$bvModal.hide("bv-modal-address");
  }

  private async getClientSelectorNames() {
    const api = ApiFactory.CreateDataClient();
    const data = await api.owner_Index(this.contactId);
    this.clientNames = data || [];
  }
  private async getClientSelectorDetails() {
    const api = ApiFactory.CreateDataClient();
    api.factFindDetails_IndexGET(this.contactId).then(result => {
      if (result) {
        this.loadDetails(result);
        this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
      } else {
        LoadingSpinnerService.Failure(
          "Could not load partner details. Please try again."
        );
      }
    });
  }
  private loadDetails(details: FactFindDetailsDto) {
    this.clientDetails = details;
  }

  private mortgageDisplayName(mortgage: FactFindPolicyDto): string {
    const owner = this.clientNames.find(x => x.id === mortgage.policyOwner);
    if (mortgage.additionalDetails) {
      return (
        (owner ? owner.name : "") +
        " - " +
        (mortgage.additionalDetails.mortgageType
          ? mortgage.additionalDetails.mortgageType.name
          : "")
      );
    } else {
      return "Unable to retrieve additional Details";
    }
  }

  private saveMortgage(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Mortgage...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateLiabilityMortgageCommand();
    cmd.additionalDetails = new CreatePolicyDetailsCommand();

    cmd.contactId = this.contactId;
    if (!this.displayDetails) {
      this.displayModel.additionalDetails = new PolicyAdditionalDetailsDto();
    }

    cmd.policyOwner = this.displayModel.policyOwner;

    cmd.policyNo = this.displayModel.policyNo;
    cmd.policyTermInYears = this.displayModel.policyTermInYears
      ? this.displayModel.policyTermInYears
      : 0;
    cmd.maturityDate = FormatDate.forApi(this.displayModel.maturityDate);

    if (this.displayModel.paymentFrequency) {
      cmd.paymentFrequencyId = this.displayModel.paymentFrequency.id;
    }

    cmd.inceptionDate = FormatDate.forApi(this.displayModel.inceptionDate);
    if (this.displayModel.provider) {
      cmd.providerId = this.displayModel.provider.id;
    }

    // Aditional Details
    cmd.additionalDetails.amountBorrowed = this.displayDetails.amountBorrowed;
    cmd.additionalDetails.currentValue = this.displayDetails.currentValue;
    cmd.additionalDetails.currentPercentageRate = this.displayDetails.currentPercentageRate;
    cmd.additionalDetails.currentBalance = this.displayDetails.currentBalance;
    cmd.additionalDetails.fixedRateTermYears = this.displayDetails.fixedRateTermYears;
    cmd.additionalDetails.monthlyRepaymentAmount = this.displayDetails.monthlyRepaymentAmount;
    cmd.additionalDetails.missedLatePayments = this.displayDetails.missedLatePayments;
    cmd.additionalDetails.propertyAddressLine_1 = this.displayDetails.propertyAddressLine_1;
    cmd.additionalDetails.propertyAddressLine_2 = this.displayDetails.propertyAddressLine_2;
    cmd.additionalDetails.propertyAddressLine_3 = this.displayDetails.propertyAddressLine_3;
    cmd.additionalDetails.propertyAddressLine_4 = this.displayDetails.propertyAddressLine_4;
    cmd.additionalDetails.propertyAddressLine_5 = this.displayDetails.propertyAddressLine_5;

    cmd.additionalDetails.currentRateEndDate = FormatDate.forApi(
      this.displayDetails.currentRateEndDate
    );
    cmd.additionalDetails.fixedRateStartDate = FormatDate.forApi(
      this.displayDetails.fixedRateStartDate
    );

    if (this.displayDetails.mortgageRateType) {
      cmd.additionalDetails.mortgageRateTypeId = this.displayDetails.mortgageRateType.id;
    }
    if (this.displayDetails.mortgageType) {
      cmd.additionalDetails.mortgageTypeId = this.displayDetails.mortgageType.id;
    }
    if (this.displayDetails.investmentProperty) {
      cmd.additionalDetails.investmentPropertyId = this.displayDetails.investmentProperty.id;
    }
    if (this.displayDetails.rentalIncome) {
      cmd.additionalDetails.rentalIncomeId = this.displayDetails.rentalIncome.id;
    }
    if (this.displayDetails.principalPrivateResidence) {
      cmd.additionalDetails.principalPrivateResidenceId = this.displayDetails.principalPrivateResidence.id;
    }

    try {
      const result = await api.factFindLiabilityMortgage_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.loadMortgages();
      this.displayModel =
        this.mortgages.find(x => x.id === result) || this.displayModel;
      this.mode = "update";
      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("Mortgage saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Mortgage. Please try again."
      );
    }

    return true;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Mortgage...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateLiabilityMortgageCommand();
    cmd.additionalDetails = new UpdatePolicyDetailsCommand();

    if (!this.displayModel.additionalDetails) {
      this.displayModel.additionalDetails = new PolicyAdditionalDetailsDto();
    }
    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.policyOwner = this.displayModel.policyOwner;
    cmd.policyNo = this.displayModel.policyNo;
    cmd.policyTermInYears = this.displayModel.policyTermInYears
      ? this.displayModel.policyTermInYears
      : 0;
    cmd.maturityDate = FormatDate.forApi(this.displayModel.maturityDate);
    cmd.inceptionDate = FormatDate.forApi(this.displayModel.inceptionDate);

    if (this.displayModel.provider) {
      cmd.providerId = this.displayModel.provider.id;
    }

    if (this.displayModel.paymentFrequency) {
      cmd.paymentFrequencyId = this.displayModel.paymentFrequency.id;
    }

    // additional details
    cmd.additionalDetails.id = this.displayModel.additionalDetails.id;
    cmd.additionalDetails.amountBorrowed = this.displayModel.additionalDetails.amountBorrowed;
    cmd.additionalDetails.currentValue = this.displayModel.additionalDetails.currentValue;
    cmd.additionalDetails.currentPercentageRate = this.displayModel.additionalDetails.currentPercentageRate;
    cmd.additionalDetails.currentBalance = this.displayModel.additionalDetails.currentBalance;
    cmd.additionalDetails.fixedRateTermYears = this.displayModel.additionalDetails.fixedRateTermYears;
    cmd.additionalDetails.monthlyRepaymentAmount = this.displayModel.additionalDetails.monthlyRepaymentAmount;
    cmd.additionalDetails.missedLatePayments = this.displayModel.additionalDetails.missedLatePayments;
    cmd.additionalDetails.propertyAddressLine_1 = this.displayModel.additionalDetails.propertyAddressLine_1;
    cmd.additionalDetails.propertyAddressLine_2 = this.displayModel.additionalDetails.propertyAddressLine_2;
    cmd.additionalDetails.propertyAddressLine_3 = this.displayModel.additionalDetails.propertyAddressLine_3;
    cmd.additionalDetails.propertyAddressLine_4 = this.displayModel.additionalDetails.propertyAddressLine_4;
    cmd.additionalDetails.propertyAddressLine_5 = this.displayModel.additionalDetails.propertyAddressLine_5;

    cmd.additionalDetails.currentRateEndDate = FormatDate.forApi(
      this.displayDetails.currentRateEndDate
    );
    cmd.additionalDetails.fixedRateStartDate = FormatDate.forApi(
      this.displayDetails.fixedRateStartDate
    );

    if (this.displayDetails.mortgageRateType) {
      cmd.additionalDetails.mortgageRateTypeId = this.displayDetails.mortgageRateType.id;
    }
    if (this.displayDetails.mortgageType) {
      cmd.additionalDetails.mortgageTypeId = this.displayDetails.mortgageType.id;
    }

    if (this.displayDetails.investmentProperty) {
      cmd.additionalDetails.investmentPropertyId = this.displayDetails.investmentProperty.id;
    }
    if (this.displayDetails.rentalIncome) {
      cmd.additionalDetails.rentalIncomeId = this.displayDetails.rentalIncome.id;
    }
    if (this.displayDetails.principalPrivateResidence) {
      cmd.additionalDetails.principalPrivateResidenceId = this.displayDetails.principalPrivateResidence.id;
    }

    try {
      await api.factFindLiabilityMortgage_IndexPUT(cmd);
      this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
      LoadingSpinnerService.Success("Mortgage updated successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Mortgage. Please try again."
      );
    }

    return false;
  }

  private async loadMortgages(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Mortgages...");
    const api = ApiFactory.CreateDataClient();
    try {
      const result = await api.factFindLiabilityMortgage_IndexAll(
        this.contactId
      );
      this.mortgages = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.mortgages = [];
      LoadingSpinnerService.Failure(
        "Could not load Mortgages. Please try again."
      );
    }
  }

  private async rowSelected(
    item: FactFindPolicyDto,
    index: number,
    event: Event
  ) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.clearData();
    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;
    this.displayDetails = item.additionalDetails
      ? item.additionalDetails
      : new PolicyAdditionalDetailsDto();
    if (this.displayModel.additionalDetails) {
      this.displayDetails = this.displayModel.additionalDetails;
    }

    this.displayModel.maturityDate = FormatDate.forInput(item.maturityDate);
    this.displayModel.inceptionDate = FormatDate.forInput(item.inceptionDate);
    this.displayModel.currentRateEndDate = FormatDate.forInput(
      item.currentRateEndDate
    );
    if (!this.displayModel.additionalDetails)
      this.displayModel.additionalDetails = new PolicyAdditionalDetailsDto();
    if (!item.additionalDetails)
      item.additionalDetails = new PolicyAdditionalDetailsDto();

    this.displayDetails.fixedRateStartDate = FormatDate.forInput(
      item.additionalDetails.fixedRateStartDate
    );

    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();

    if (this.displayModel.policyOwner) {
      this.$refs.owner.setSelected(this.displayModel.policyOwner);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.$refs.rentalIncome.setSelected(this.displayDetails.rentalIncome);

    if (this.displayModel.additionalDetails) {
      this.$refs.mortgageType.setSelected(this.displayDetails.mortgageType);
    }

    this.$refs.productProvider.setSelected(this.displayModel.provider);
    this.$refs.mortgageRateType.setSelected(
      this.displayDetails.mortgageRateType
    );
    this.$refs.paymentFrequency.setSelected(this.displayModel.paymentFrequency);
    this.$refs.investmentProperty.setSelected(
      this.displayDetails.investmentProperty
    );
    this.$refs.privateResidence.setSelected(
      this.displayDetails.principalPrivateResidence
    );
  }

  private saveClicked() {
    this.formEnabled = false;
    this.clearData();
    this.mode = "default";
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private updateClicked() {
    this.mode = "update";
    this.formEnabled = true;
  }

  private clearData() {
    this.displayModel = this.emptyMortgage;
    this.displayDetails = this.emptyDetails;

    this.displayModel.policyOwner = ClientSelector.Main;
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.rentalIncome.setSelected(new YesNoDefaultDto());
    this.$refs.mortgageType.setSelected(new MortgageTypeDto());
    this.$refs.productProvider.setSelected(new ProductProviderDto());
    this.$refs.mortgageRateType.setSelected(new MortgageRateDto());
    this.$refs.paymentFrequency.setSelected(new PaymentFrequencyDto());
    this.$refs.investmentProperty.setSelected(new YesNoDefaultDto());
    this.$refs.privateResidence.setSelected(new YesNoDefaultDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyMortgage.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    console.log("s1: " + s1);
    console.log("s2" + this.modelSig);
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.policyOwner = owner;
  }

  private lenderSelected(lender: ProductProviderDto) {
    this.displayModel.provider = lender;
  }

  private mortgageTypeSelected(mortgageType: MortgageTypeDto) {
    this.displayDetails.mortgageType = mortgageType;
  }
  private rentalIncomeSelected(rentalIncome: YesNoDefaultDto) {
    this.displayDetails.rentalIncome = rentalIncome;
  }

  private mortgageRateTypeSelected(rateType: MortgageRateDto) {
    this.displayDetails.mortgageRateType = rateType;
  }

  private paymentFrequencySelected(paymentFrequency: PaymentFrequencyDto) {
    this.displayModel.paymentFrequency = paymentFrequency;
  }

  private investmentPropertySelected(investmentProperty: YesNoDefaultDto) {
    this.displayDetails.investmentProperty = investmentProperty;
  }
  private getAddress() {
    var address;
    if (this.displayModel.policyOwner === 2) {
      address = this.clientDetails.sP_AddressLine_1;
      address = address + "\n" + this.clientDetails.sP_AddressLine_2;
      address = address + "\n" + this.clientDetails.sP_AddressLine_3;
      address = address + "\n" + this.clientDetails.sP_AddressLine_4;
    } else {
      address = this.clientDetails.addressLine_1;
      address = address + "\n" + this.clientDetails.addressLine_2;
      address = address + "\n" + this.clientDetails.addressLine_3;
      address = address + "\n" + this.clientDetails.addressLine_4;
    }
    return address;
  }
  handleNewLine(str: string) {
    return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
  }
  private assignAddress() {
    this.$bvModal.hide("bv-modal-address");
    var updateModel = PolicyAdditionalDetailsDto.fromJS(this.displayDetails);
    if (this.displayModel.policyOwner === 2) {
      updateModel.propertyAddressLine_1 = this.clientDetails.sP_AddressLine_1;
      updateModel.propertyAddressLine_2 = this.clientDetails.sP_AddressLine_2;
      updateModel.propertyAddressLine_3 = this.clientDetails.sP_AddressLine_3;
      updateModel.propertyAddressLine_4 = this.clientDetails.sP_AddressLine_4;
    } else {
      updateModel.propertyAddressLine_1 = this.clientDetails.addressLine_1;
      updateModel.propertyAddressLine_2 = this.clientDetails.addressLine_2;
      updateModel.propertyAddressLine_3 = this.clientDetails.addressLine_3;
      updateModel.propertyAddressLine_4 = this.clientDetails.addressLine_4;
    }
    this.displayDetails = updateModel;
  }

  private principalPrivateResidenceSelected(privateResidence: YesNoDefaultDto) {
    this.displayDetails.principalPrivateResidence = privateResidence;

    if (this.displayDetails.principalPrivateResidence.name === "Yes") {
      this.displayAddress = this.getAddress();
      this.$bvModal.show("bv-modal-address");
    }
  }
}
